import { render, staticRenderFns } from "./AddRegion.vue?vue&type=template&id=350d9c83&"
import script from "./AddRegion.vue?vue&type=script&lang=js&"
export * from "./AddRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports